import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios";
import { IEntePA } from "../shared/interfaces";

const controller = 'IndicePA';



const searchEntePA = (aooId: number, searchValue: string, cancelToken?: CancelToken): Promise<IEntePA[]> => {
    return axiosInstance.post(`${controller}/${aooId}/SearchEntePA`, searchValue, { cancelToken: cancelToken, headers: { 'Content-Type': 'application/json' } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getEntePA = (aooId: number, codiceIPA: string, cancelToken?: CancelToken): Promise<IEntePA> => {
    return axiosInstance.get(`${controller}/${aooId}/GetEntePA`, { cancelToken: cancelToken, params: { codiceIPA } })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}




export default {
    searchEntePA,
    getEntePA
}